import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiService } from '../../shared/services/rest-api.service';
import { ConfigService } from '../../shared/services/config.service';
import { RoleModel, UserModel, BulkActionData, UserActionData, RoleActionData, ResetPasswordData } from '../models/user-management';
import { EntityList } from '../../shared/models/entity.models';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {
  constructor(
    private restApiService: RestApiService, private confService: ConfigService
  ) { }

  getAttributeDefinition(entityType: string): Observable<unknown> {
    return this.restApiService.get(' Attribute Definition', `${this.confService.getLoggedInTenantCode()}/api/v1/attributes/${entityType}?forTenantCode=${this.confService.getForTenantCode()}`, 'page-center');
  }

  addRole(roleModel: RoleModel): Observable<unknown> {
    return this.restApiService.post('', '/secure/roles', roleModel, 'page-center');
  }

  getRole(roleId: string): Observable<unknown> {
    return this.restApiService.get('', `/secure/roles/${roleId}`, 'page-center');
  }

  getRoles(): Observable<unknown> {
    return this.restApiService.get('', '/secure/roles', 'page-center');
  }

  getLoginUserRoles(): Observable<unknown> {
    return this.restApiService.get('', '/secure/user-roles', 'page-center');
  }

  getLoginUserCities(): Observable<unknown> {
    return this.restApiService.get('', '/secure/service-area/cities', 'page-center');
  }

  getAllRoleAccesses(): Observable<unknown> {
    return this.restApiService.get('', '/secure/accesses-list', 'page-center');
  }

  updateRole(roleId: string, roleModel: RoleModel): Observable<unknown> {
    return this.restApiService.put('', `/secure/roles/${roleId}`, roleModel, 'page-center');
  }

  activeDeactiveRoleStatus(roleId: string, data: UserActionData): Observable<unknown> {
    return this.restApiService.put('', `/secure/roles/${roleId}/status`, data, 'page-center');
  }

  addUser(userModel: UserModel): Observable<unknown> {
    return this.restApiService.post('', '/secure/users', userModel, 'page-center');
  }

  getUser(userId: string): Observable<unknown> {
    return this.restApiService.get('', `/secure/users/${userId}`, 'page-center');
  }

  updatUser(userId: string, userModel: UserModel): Observable<unknown> {
    return this.restApiService.put('', `/secure/users/${userId}`, userModel, 'page-center');
  }

  updateUserStatus(userId: string, data: UserActionData): Observable<unknown> {
    return this.restApiService.put('', `/secure/users/${userId}/status`, data, 'page-center');
  }

  searchEntity(data: EntityList, loader?: boolean): Observable<unknown> {
    return this.restApiService.post('SEARCH ENTITY', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/search?forTenantCode=${this.confService.getForTenantCode()}`, data, loader ? 'page-center' : '');
  }

  searchEntityUser(data: EntityList): Observable<unknown> {
    return this.restApiService.post('SEARCH ENTITY', `${this.confService.getLoggedInTenantCode()}/api/v1/users/search?forTenantCode=${this.confService.getForTenantCode()}`, data, 'page-center');
  }

  getDetails(data: string[]): Observable<unknown> {
    return this.restApiService.post('GET USER DETAILS',`${this.confService.getLoggedInTenantCode()}/api/v1/users/user-details?forTenantCode=${this.confService.getForTenantCode()}`,data,'page-center');
  }

  searchEvent(data: EntityList): Observable<unknown> {
    return this.restApiService.post('SEARCH EVENT', `${this.confService.getLoggedInTenantCode()}/api/v1/events/user-events`, data, 'page-center');
  }

  deleteBulkActionStatus(data: BulkActionData): Observable<unknown> {
    return this.restApiService.put('delete Roles', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/bulk-delete`, data);
  }

  deleteBulkUserActionStatus(data: BulkActionData): Observable<unknown> {
    return this.restApiService.put('delete Users', `${this.confService.getLoggedInTenantCode()}/api/v1/users/bulk-delete`, data);
  }

  updateBulkUserActionStatus(data: BulkActionData): Observable<unknown> {
    return this.restApiService.put('Update Bulk Users', `${this.confService.getLoggedInTenantCode()}/api/v1/users/bulk-update`, data);
  }

  updateBulkRoleActionStatus(data: BulkActionData): Observable<unknown> {
    return this.restApiService.put('Update Bulk Roles', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/bulk-update`, data);
  }

  updateUserActionStatus(userId: string, data: UserActionData): Observable<unknown> {
    return this.restApiService.put('Update User Status', `${this.confService.getLoggedInTenantCode()}/api/v1/users/${userId}/action`, data, 'page-center');
  }

  updateRoleActionStatus(roleId: string, data: RoleActionData): Observable<unknown> {
    return this.restApiService.put('Update Role Status', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/${roleId}/action`, data, 'page-center');
  }

  AddNewUser(data: Record<string, unknown>): Observable<unknown> {
    return this.restApiService.post('Save User', `${this.confService.getLoggedInTenantCode()}/api/v1/users`, data, 'page-center');
  }

  getUserDetails(userId: string): Observable<unknown> {
    return this.restApiService.get('User Detail', `${this.confService.getLoggedInTenantCode()}/api/v1/users/${userId}?forTenantCode=${this.confService.getForTenantCode()}`, 'page-center');
  }

  EditUser(userId: string, data: Record<string, unknown>): Observable<unknown> {
    return this.restApiService.put('Update User', `${this.confService.getLoggedInTenantCode()}/api/v1/users/${userId}`, data, 'page-center');
  }

  getPermissionMenus(): Observable<unknown> {
    return this.restApiService.get('Permission Menus', `${this.confService.getLoggedInTenantCode()}/api/v1/menus?forTenantCode=${this.confService.getForTenantCode()}`, 'page-center');
  }

  AddNewRole(data: RoleModel): Observable<unknown> {
    return this.restApiService.post('Save Role', `${this.confService.getLoggedInTenantCode()}/api/v1/roles`, data, 'page-center');
  }

  getRoleDetails(roleId: string): Observable<unknown> {
    return this.restApiService.get('Role Detail', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/${roleId}?forTenantCode=${this.confService.getForTenantCode()}`, 'page-center');
  }

  EditRole(roleId: string, data: RoleModel): Observable<unknown> {
    return this.restApiService.put('Update Role', `${this.confService.getLoggedInTenantCode()}/api/v1/roles/${roleId}`, data, 'page-center');
  }

  resetPassword(userId: string, data: ResetPasswordData): Observable<unknown> {
    return this.restApiService.put('Reset Password', `${this.confService.getLoggedInTenantCode()}/api/v1/users/${userId}/reset-password`, data, 'page-center');
  }

}
